import { AIGenerationData } from '../../common/linqset-model'
import { MODEL_NAME_MAX } from '../../common/organisation'

// what the user told getting started about their process
export interface ProcessAnswers {
    industry:string
    function:string
    description:string
    starts:string[]         // what starts the process, and how often
    roles:string[]
    systems:string[]
    outcomes:string[]
    more:string             // anything else AI should know
}

export const ANSWER_MAX = 20            // items in each list
export const ANSWER_ITEM_MAX = 100      // characters in each item

// the questions about a process, with examples of answers. Every one is optional: AI fills in what is typical
export const PROCESS_QUESTIONS:{key:'starts'|'roles'|'systems'|'outcomes', label:string, hint:string}[] = [
    {key:'starts', label:"What starts the process, and how often?", hint:"e.g. Customer order, about 40 a day"},
    {key:'roles', label:"Who's involved?", hint:"e.g. Sales assistant, Warehouse team, Finance"},
    {key:'systems', label:"What systems or tools do they use?", hint:"e.g. Shopify, Excel, Xero"},
    {key:'outcomes', label:"What does it produce?", hint:"e.g. Order delivered, Invoice paid"},
]

// a list answer with a new item, if it is worth adding: trimmed, not repeated (whatever its case), and within the limits
export const addAnswer = (answers:string[], value:string|undefined):string[] => {
    const item = (value || '').trim().slice(0, ANSWER_ITEM_MAX)
    if (!item || answers.length >= ANSWER_MAX || answers.some(a => a.toLowerCase() === item.toLowerCase())) return answers
    return [...answers, item]
}

// a name to start from once a function is chosen
export const suggestModelName = (modelFunction:string) => `${modelFunction} process`.slice(0, MODEL_NAME_MAX)

// the answers as AI takes them. A file is described by its type; the file itself goes alongside
export const toAIData = (answers:ProcessAnswers, fileType?:string, processDescription?:string):AIGenerationData => {
    const data:AIGenerationData = {
        industry: answers.industry,
        function: answers.function,
        description: answers.description.trim(),
        captures: answers.starts,
        roles: answers.roles,
        systems: answers.systems,
        outcomes: answers.outcomes,
        transcript: answers.more.trim(),
    }
    if (fileType) data.fileType = fileType
    if (processDescription?.trim()) data.processDescription = processDescription.trim()
    return data
}
